const state = {
  numeroDocumento: undefined,
  idTipoDocumento: undefined,
  idUnidadeAtual: undefined,
  dataEnvioInicio: undefined,
  dataEnvioFim: undefined,
  listaTiposDocumento: [],
  listaUnidadesAutorizadas: [],
  listaDocumentos: [],
  buscandoDocumentosCaixaPostal: false
}

export default state
